var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgScreenOnScreenExit = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.075 12.5L16.5 11.075L13.4 8H16V6H10V12H12V9.425L15.075 12.5ZM0 5V0H7V5H0ZM0 7H9V0H18C18.55 0 19.0208 0.195833 19.4125 0.5875C19.8042 0.979167 20 1.45 20 2V14C20 14.55 19.8042 15.0208 19.4125 15.4125C19.0208 15.8042 18.55 16 18 16H2C1.45 16 0.979167 15.8042 0.5875 15.4125C0.195833 15.0208 0 14.55 0 14V7Z",
    fill: "#1C1B1F"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgScreenOnScreenExit);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyMCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjA3NSAxMi41TDE2LjUgMTEuMDc1TDEzLjQgOEgxNlY2SDEwVjEySDEyVjkuNDI1TDE1LjA3NSAxMi41Wk0wIDVWMEg3VjVIMFpNMCA3SDlWMEgxOEMxOC41NSAwIDE5LjAyMDggMC4xOTU4MzMgMTkuNDEyNSAwLjU4NzVDMTkuODA0MiAwLjk3OTE2NyAyMCAxLjQ1IDIwIDJWMTRDMjAgMTQuNTUgMTkuODA0MiAxNS4wMjA4IDE5LjQxMjUgMTUuNDEyNUMxOS4wMjA4IDE1LjgwNDIgMTguNTUgMTYgMTggMTZIMkMxLjQ1IDE2IDAuOTc5MTY3IDE1LjgwNDIgMC41ODc1IDE1LjQxMjVDMC4xOTU4MzMgMTUuMDIwOCAwIDE0LjU1IDAgMTRWN1oiIGZpbGw9IiMxQzFCMUYiLz4KPC9zdmc+Cg==";